import { Temporal } from '@js-temporal/polyfill'

import { formatPlainTemporal } from '@buffer-mono/popcorn'

export function formatUpNextTime(
  dueAt: string,
  timezone: string,
  timeFormat: '12' | '24',
): string {
  const zoned = Temporal.Instant.from(dueAt).toZonedDateTimeISO(timezone)
  const now = Temporal.Now.zonedDateTimeISO(timezone)
  const today = now.startOfDay()
  const tomorrow = today.add({ days: 1 })

  const timeLabel = formatTimeLabel(zoned, timeFormat)

  const zonedDate = zoned.toPlainDate()
  if (zonedDate.equals(today.toPlainDate())) {
    return `Today ${timeLabel}`
  }
  if (zonedDate.equals(tomorrow.toPlainDate())) {
    return `Tomorrow ${timeLabel}`
  }

  const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  }
  if (zoned.year !== now.year) {
    dateOptions.year = 'numeric'
  }
  const dateLabel = formatPlainTemporal(
    zoned.toPlainDate(),
    undefined,
    dateOptions,
  )

  return `${dateLabel}, ${timeLabel}`
}

function formatTimeLabel(
  date: Temporal.ZonedDateTime,
  timeFormat: '12' | '24',
): string {
  if (timeFormat === '24') {
    return formatPlainTemporal(date.toPlainTime(), undefined, {
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
  }

  const hour = date.hour % 12 || 12
  const minute = date.minute
  const suffix = date.hour < 12 ? 'AM' : 'PM'
  if (minute === 0) {
    return `${hour} ${suffix}`
  }
  return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`
}
